import cn from 'classnames';

export default function Title({ title, className, prefix }) {
  return <h1 className={cn(`${prefix}pb-2 ${prefix}font-bold ${prefix}truncate`, className)}>{title}</h1>;
}
